import React, { Component } from "react";
import Card from "../../components/Card/Card.jsx";
import "../../assets/css/video-js.css";
import "../../assets/css/streams-page.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {withRouter} from 'react-router-dom'
import * as actions from "../../actions/streamListActions";
import ReactTable from "react-table";
import "react-table/react-table.css";
import videojs from 'video.js'
import { KeyValueDropdown } from "../../components/Dropdown/KeyValueDropdown";
import {
  Grid,
  Row,
  Col,
  Panel,
  Tooltip,
  OverlayTrigger,
  Modal
} from "react-bootstrap";

import Button from "../../components/CustomButton/CustomButton.jsx";
import { stringify } from "querystring";

class StreamList extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      containers: {},
      inputStatus: {},
      outputStatus: {},
      programids:[],
      controls: {visible: true},
      selectedRow: -1,
      selection: false,
      showVideoModal: false,
      showMulticastVideoModal: false,
      playVideo: {},
      playContainer:{},
      pageSize: props.pageSize,
      enableTSStats: props.enableTSStats,
      enableVideoPreview: props.enableVideoPreview,
      showFeaturesAlert: false
    };

    this.serverIP = window.location.host;
    if(this.serverIP.startsWith("localhost")) {
      this.serverIP = '192.168.1.102';
    }
    this.previewPlayer = null;

    this.handleStartStream = this.handleStartStream.bind(this);
    this.handleStopStream = this.handleStopStream.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleDeleteStream = this.handleDeleteStream.bind(this);
    this.handleEditStream = this.handleEditStream.bind(this);
    this.openVideo = this.openVideo.bind(this);
    this.closeVideo = this.closeVideo.bind(this);
    this.closeMulticastVideo = this.closeMulticastVideo.bind(this);
    this.initIntervalHandle = null;
    this.intervalHandleInput = null;
    this.intervalHandleOutput = null;
    this.intervalHandlePlayer = null;
    this.timeoutHandlePlayer = null;
    this.updateState = this.updateState.bind(this);

  }
  
  updateState = (value, label) => {
    const playVideo = this.state.playVideo;
    const playContainer = this.state.playContainer;
    if(this.state.playContainer){
      let containerId =  this.state.playContainer.Id;
      const { selectedProgramId } = this.props.actions;
      selectedProgramId(value, containerId, playVideo.protocol, playVideo.ip, playVideo.port, window.location.origin)
      .then((response) => {
        //set the player for selected program
        this.setState({ showMulticastVideoModal: true });
        let mediaDir = playContainer.Id.substring(0, 12)+"_"+Number(value);
        let videoUrl = 'http://'+this.serverIP+'/preview/' + mediaDir+"/live.m3u8";
        playVideo["videoUrl"] = videoUrl;
        this.setState({ playVideo: playVideo});
        setTimeout(() => {
          this.playPreview(videoUrl);
        },5000);
      });
    }
  } 
  componentDidMount() {
    const { getStreams, getLocalConfig } = this.props.actions;
    getStreams(window.location.origin);
    setInterval(() => getStreams(window.location.origin),1*60*1000);
    getLocalConfig();

    this.initIntervalHandle = setInterval(() => {
      if(this.props.containers && this.props.containers.length > 0 && this.props.containers[0].Id != 0) {
        clearInterval(this.initIntervalHandle);
        if(this.state.selectedRow == -1 && this.props.enableTSStats) {
          this.loadTSReport(this.props.containers[0]);
        }
      }
    }, 500);
  }
// componentWillReceiveProps(nextProps) {
//   if(nextProps.containers[0].sourceProtocol != "" && nextProps.containers[0].destProtocol !== ""){
//     this.setState({controls: {visible: false}})
//   }
// }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  onRowClick = (row) => {
    this.setState({
      selectedRow: true
    });
  };

  handleRowClick(id) {
    getStreams(id,window.location.origin);
  }

  handleStartStream(e) {
    e.preventDefault();
    this.props.actions
      .startStream(e.target.id, window.location.origin)
      .then(id => console.log(`started container with id ${id}`));
  }

  handleStopStream(e) {
    e.preventDefault();
    this.props.actions
      .stopStream(e.target.id, window.location.origin)
      .then(id => console.log(`stopped container with id ${id}`));
  }

  handleDeleteStream(e) {
    e.preventDefault();
    this.props.actions
      .deleteStream(e.target.id, window.location.origin)
      .then(id => console.log(`deleted container with id ${id}`));
  }

  handleEditStream(e) {
    e.preventDefault();
    if(!e.target.id)
      return;
    // this.props.actions
    //   .editStream(e.target.id);
    let streamConfigUrl = `/streamconfig/${e.target.id}`;
      this.props.history.push(streamConfigUrl);
  }

  openVideo(e) {
    e.preventDefault();
    var thisobj = this;
    let playContainer = this.props.containers.find((item)=>{
      return item.Id==e.target.id;
    });
    if(playContainer) {
      if(playContainer.destProtocol.toLowerCase() === "dash" || playContainer.destProtocol.toLowerCase() === "hls") {
        this.setState({ showVideoModal: true });
        let mediaDir = playContainer.destDashDir || playContainer.Id.substring(0, 12);
        let dashLocation = '/media/' + mediaDir;
        if(playContainer.destProtocol.toLowerCase() === "dash") {
          dashLocation+='/live.mpd';
        } else {
          dashLocation+='/live.m3u8';
        }
        this.setState({ playVideo: {
          title: playContainer.comment,
          dashLocation: dashLocation,
          destProtocol: playContainer.destProtocol
        }});
        setTimeout(function(self){
          self.initApp();
        },500, this);
      } else { //non hls, dash, hence needs conversion
        var playMulticastVideo = false;
        var playVideo = {};
        if (playContainer.sourceIP.startsWith("@")) {
          console.log("loading preview for multicast source", playContainer.sourceIP);
          playMulticastVideo = true;
          playVideo = {
            protocol: playContainer.sourceProtocol,
            ip: playContainer.sourceIP,
            port: playContainer.sourcePort
          };
        }
        if (!playMulticastVideo && playContainer.destIP.startsWith("@")) {
          console.log("loading preview for multicast dest", playContainer.destIP);
          playMulticastVideo = true;
          playVideo = {
            protocol: playContainer.destProtocol.toLowerCase() === "qam" ? "UDP" : playContainer.destProtocol,
            ip: playContainer.destIP,
            port: playContainer.destPort
          };
        }
        if(playMulticastVideo) {
          const { previewStream } = this.props.actions;
          previewStream(playContainer.Id.substring(0, 12), playVideo.protocol, playVideo.ip, playVideo.port, window.location.origin)
          .then((response) => {
            this.setState({ showMulticastVideoModal: true});
            if(response && response.programids && response.programids.length>1){ //show dropdown of programs
              this.setState({programids: response.programids, playContainer: playContainer, playVideo: playVideo });
            } else { //play video if no or 1 program
              let mediaDir = playContainer.Id.substring(0, 12);
              let videoUrl = 'http://'+this.serverIP+'/preview/' + mediaDir+"/live.m3u8";
              playVideo["title"] = playContainer.comment;
              playVideo["videoUrl"] = videoUrl;
              this.setState({ playVideo: playVideo});
              setTimeout(() => {
                this.playPreview(videoUrl);
              },5000);
            }
          }); 
        } else {
          console.log("not a multicase video, preview not available.")
          this.setState({ playVideo: {}});
        }
      }
    } else {
      this.setState({ playVideo: {}});
    }
  }

  playPreview(videoToPlay) {
    console.log("playing:", videoToPlay);
    if(this.previewPlayer) {
      this.previewPlayer.src({src: videoToPlay});
    } else {
      var options = {
        sources: [{
          src: videoToPlay
        }],
        controls: true,
        autoplay: true,
        fluid: true
        // liveui: true,
        // liveTracker: true
      };
      this.previewPlayer = videojs("video_preview", options);
    }
    if(this.intervalHandlePlayer) clearInterval(this.intervalHandlePlayer);
    if(this.timeoutHandlePlayer) clearTimeout(this.timeoutHandlePlayer);
    this.intervalHandlePlayer = setInterval(() => {
      if(this.previewPlayer) {
        console.log("currentTime:", this.previewPlayer.currentTime(), "readyState:", this.previewPlayer.readyState());
        if(this.previewPlayer.currentTime() == 0) {
          this.previewPlayer.src({src: videoToPlay});
        } else if(this.intervalHandlePlayer) {
          clearInterval(this.intervalHandlePlayer);
          if(this.timeoutHandlePlayer) clearTimeout(this.timeoutHandlePlayer);
        }
      }
    }, 3000);
    this.timeoutHandlePlayer = setTimeout(() => {
      if(this.intervalHandlePlayer) clearInterval(this.intervalHandlePlayer);
      console.log("could not play video.");
    }, 60 * 1000);
  }

  closeVideo(){
    console.log('closing video');
    this.setState({ showVideoModal: false });
    window.player.unload();
    window.player.destroy();
  }

  closeMulticastVideo(){
    console.log('closing multicast video');
    this.setState({ showMulticastVideoModal: false });
    if(this.previewPlayer) {
      this.previewPlayer.dispose();
      this.previewPlayer = null;
    }
  }

  initApp() {
	  // Install built-in polyfills to patch browser incompatibilities.
	  shaka.polyfill.installAll();

	  // Check to see if the browser supports the basic APIs Shaka needs.
	  if (shaka.Player.isBrowserSupported()) {
	    // Everything looks good!
	    this.initPlayer();
	  } else {
	    // This browser does not have the minimum set of APIs we need.
	    console.error('Browser not supported!');
	  }
	}

	initPlayer() {
	  // Create a Player instance.
	  var video = document.getElementById('video');
    var player = new shaka.Player(video);

	  // Attach player to the window to make it easy to access in the JS console.
    window.player = player;
    
    player.configure({
      streaming: {
        bufferBehind: 26,
        bufferingGoal: 1,
        durationBackoff: 1,
        ignoreTextStreamFailures: true,
        alwaysStreamText: false,
        jumpLargeGaps: true,
        rebufferingGoal: 0,
        smallGapLimit: 0.5,
        startAtSegmentBoundary: false,
        forceTransmuxTS: true,
        alwaysStreamText: true,
        failureCallback: function(error) {
          console.log('failureCallback error:', error);
          if (player.isLive()) player.retryStreaming();
        }
      }
    });

	  // Listen for error events.
	  player.addEventListener('error', function(event) {
	  // Extract the shaka.util.Error object from the event.
	      console.error('Error code', event.detail.code, 'object', event.detail);
	  });

	  //player.configure({'streamBufferSize': 1});
	  // Try to load a manifest.
	  // This is an asynchronous process.
	  player.load(this.state.playVideo.dashLocation).then(function() {
	    // This runs if the asynchronous load is successful.
      console.log('The video has now been loaded!');
      video.play();
	  }).catch(function(error) {
	  // Log the error.
	    console.error('Error code', error.code, 'object', error);
	  });  // onError is executed if the asynchronous load fails.

  }
  
  getDashLink() {
    return window.location.protocol+ '//' + window.location.hostname + (window.location.port?':' + window.location.port:'') + (this.state.playVideo.dashLocation?this.state.playVideo.dashLocation:'')
  }

  getPreviewTitle() {
    if(this.state.playVideo.destProtocol && this.state.playVideo.destProtocol.toLowerCase() === "dash") {
      return "Preview Dash Stream";
    } else if(this.state.playVideo.destProtocol && this.state.playVideo.destProtocol.toLowerCase() === "hls") {
        return "Preview Hls Stream";
    } else {
      return "Preview non-Dash/Hls Stream";
    }
  }

  enablePreview(container) {
    if(container.state === "running") {
      if(container.destProtocol.toLowerCase() === "dash" || container.destProtocol.toLowerCase() === "hls") {
        return true;
      } else if(this.props.enableVideoPreview === true) {
        if (container.sourceIP.startsWith("@")) {
          return true;
        }
        if (container.destIP.startsWith("@")) {
          return true;
        }
      }
    }
    return false;
  }

  getRowColor(containerId) {
    //console.log('-----------inputStatus:', this.props.inputStatus, '-----------outputStatus:', this.props.outputStatus);
    const inputStatus = this.props.inputStatus[containerId] || null;
    const outputStatus = this.props.outputStatus[containerId] || null;
    const container = this.props.containers.find((item)=>{
      return item.Id==containerId;
    });
    //console.log('inputStatus:', inputStatus);
    //console.log('outputStatus:', outputStatus);
    if(container) {
      if(container.sourceProtocol.toLowerCase() === "srt" && inputStatus && inputStatus.connected === false) {
        return "#efaeae"; //red
      }
      if(container.destProtocol.toLowerCase() === "srt" && outputStatus && outputStatus.connected === false) {
        return "#efaeae"; //red
      }
      if(inputStatus && (inputStatus.dropped || inputStatus.lost)) {
        return "#efe8ae"; //yellow
      }
      if(outputStatus && (outputStatus.dropped || outputStatus.lost)) {
        return "#efe8ae"; //yellow
      }
    }
    return "#d5efae"; //green
  }

  getCell(row) {
    if (this.props.containers[0].sourceProtocol === "" && this.props.containers[0].destProtocol === "")
      return (<div></div>);

    else {
      const play = <Tooltip id="play_tooltip">Start Stream</Tooltip>;
      const stop = <Tooltip id="stop_tooltip">Stop Stream</Tooltip>;
      const edit = <Tooltip id="edit_tooltip">Edit Stream</Tooltip>;
      const remove = <Tooltip id="remove_tooltip">Remove Stream</Tooltip>;
      const preview = <Tooltip id="preview_tooltip">Preview Stream</Tooltip>;

      return (
        <div style={{ display: "flex" }}>
          <OverlayTrigger placement="top" overlay={play}>
            <Button
              bsStyle="info"
              simple
              type="button"
              bsSize="xs"
              onClick={(e) => {this.handleStartStream(e)}}
              style={{visibility: ((row && row.original.state !== "running") ? "visible" : "hidden")}}
              id={row.original.Id}
            >
              <i className="fa fa-play" id={row.original.Id} />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={stop}>
            <Button
              bsStyle="info"
              simple
              type="button"
              bsSize="xs"
              onClick={(e) => {this.handleStopStream(e)}}
              style={{visibility: ((row && row.original.state === "running") ? "visible" : "hidden")}}
              id={row.original.Id}
            >
              <i className="fa fa-stop" id={row.original.Id}  />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={edit}>
            <Button bsStyle="info" simple type="button" bsSize="xs" onClick={(e) => this.handleEditStream(e)}>
              <i className="fa fa-edit" id={row.original.Id} />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={preview}>
            <Button
              bsStyle="info"
              simple
              type="button"
              bsSize="xs"
              onClick={(e) => {this.openVideo(e)}}
              style={{visibility: ((row && this.enablePreview(row.original)) ? "visible" : "hidden")}}
              id={row.original.Id}
            >
              <i className="fa fa-video-camera" id={row.original.Id}  />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={remove} id={row.original.Id} >
            <Button
              bsStyle="danger"
              simple
              type="button"
              bsSize="xs"
              onClick={(e) => this.handleDeleteStream(e)}
            >
              <i className="fa fa-times" id={row.original.Id} />
            </Button>
          </OverlayTrigger>
        </div>
      )
    }
  }
  // getColumns() {
  //   const columns = [];

  //   Object.keys(this.props.containers).forEach(key => {
  //     if (key !== "id") {
  //       columns.push({
  //         accessor: key,
  //         Header: key
  //       });
  //     }
  //   });
  //   return columns;
  // }

  isSelected = key => {
    /*
      Instead of passing our external selection state we provide an 'isSelected'
      callback and detect the selection state ourselves. This allows any implementation
      for selection (either an array, object keys, or even a Javascript Set object).
    */
    return this.state.selection.includes(key);
  };

  loadTSReport(container) {
    const { getTSTableReport, clearTSTableReport } = this.props.actions;
    var containerHaveMulticastStream = false;
    if(this.intervalHandleInput) clearInterval(this.intervalHandleInput);
    if(this.intervalHandleOutput) clearInterval(this.intervalHandleOutput);
    clearTSTableReport();
    
    if (container.sourceIP.startsWith("@")) {
      containerHaveMulticastStream = true;
      if(container.state === "running") {
        getTSTableReport("input", container.Id, "tstables", container.sourceIP, container.sourcePort, container.sourceSSMIP, window.location.origin);
        this.intervalHandleInput = setInterval(() => getTSTableReport("input", container.Id, "tstables", container.sourceIP, container.sourcePort, container.sourceSSMIP, window.location.origin), container.interval*1000);
      }
    }
    if (container.destIP.startsWith("@")) {
      containerHaveMulticastStream = true;
      if(container.state === "running") {
        getTSTableReport("output", container.Id, "tstables", container.destIP, container.destPort, null, window.location.origin);
        this.intervalHandleOutput = setInterval(() => getTSTableReport("output", container.Id, "tstables", container.destIP, container.destPort, null, window.location.origin), container.interval*1000);
      }
    }
    if(containerHaveMulticastStream) {
      this.setState({ showFeaturesAlert: false });
    } else {
      this.setState({ showFeaturesAlert: true });
    }
  }

  render() {
    const columns = [
      {
        id: "inputStream",
        Header: "Input Stream",
        accessor: d => d.inputStream
      },
      {
        id: "outputStream",
        Header: "Output Stream",
        accessor: d => d.outputStream
      },
      {
        id: "comment",
        Header: "Comment",
        accessor: d => d.comment
      },
      {
        Header: props => <span>Controls</span>, // Custom header components!
        accessor: "controls",
        //show: {this.props.controls.visible},
        Cell: row => (
          this.getCell(row)
        )
      }
    ];

    // onPageSizeChange={(pageSize, pageIndex) => {
    //   this.state.pageSize = pageSize;
    // }}

    return (
      <div className="content">
        <Grid fluid>
          <Panel bsStyle="primary">
            <Panel.Heading>
              <Panel.Title componentClass="h3">Stream List</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <Row>
                <Col
                  md={12}
                  style={{ paddingLeft: 1 + "px", paddingRight: 1 + "px" }}
                >
                  <Card
                    ctTableFullWidth
                    ctTableResponsive
                    plain
                    noFooter
                    content={
                      <div>
                        <ReactTable
                          getTdProps={(state, rowInfo) => {

                              return {
                                onClick: e => {
                                  //this.onRowClick(rowInfo.row._original);
                                  this.setState({
                                    selectedRow: rowInfo.index,
                                    selection: true
                                  });
                                  const { subscribeToStats, getTSTableReport } = this.props.actions;
                                  subscribeToStats(rowInfo.original.Id, window.location.origin);
                                  if(this.props.enableTSStats) {
                                    this.loadTSReport(rowInfo.original);
                                  }
                                },
                                style: {
                                  background: (rowInfo) ? (rowInfo.index === this.state.selectedRow ? '#9b9fa0' : '') : 'content'
                                }
                                  //background: (rowInfo !== undefined) ? (rowInfo.row.selected ? 'green' : 'red') : ''

                                }
                            }
                          }
                          // }
                          getTrProps={(state, rowInfo, column) => {

                              return {
                                style:{background: ((rowInfo && rowInfo.original.state === "running") ? this.getRowColor(rowInfo.original.Id) : "")}
                              };
                            }
                          }
                          showPagination={true}
                          showPageSizeOptions={true}
                          defaultPageSize={this.props.pageSize}
                          pageSize={this.props.pageSize}
                          data={this.props.containers}
                          columns={columns}
                          className="-striped -highlight"
                          onPageSizeChange={(pageSize) => {
                            this.setState({ pageSize: pageSize });
                            const { setLocalConfig } = this.props.actions;
                            setLocalConfig('pageSize', pageSize);
                          }}
                          // style={{
                          //   height: "300px" // This will force the table body to overflow and scroll, since there is not enough room
                          // }}
                        >
                        </ReactTable>
                      </div>
                    }
                  />
                </Col>
              </Row>
            </Panel.Body>
          </Panel>
        </Grid>
        {(this.props.enableTSStats || this.props.enableVideoPreview) && this.state.showFeaturesAlert &&
        <div className="alert alert-info features-alert">
          <span>Advanced features like {this.props.enableTSStats ? "TS statistics": ""} {this.props.enableTSStats && this.props.enableVideoPreview ? " and ": ""}{this.props.enableVideoPreview ? "video preview": ""} will not be available for unicast input and output.</span>
        </div>}
        <Modal
          {...this.props}
          bsSize="large"
          aria-labelledby='dash-player-modal'
          show={this.state.showVideoModal}
          onHide={this.closeVideo}
        >
          <Modal.Header closeButton>
            <Modal.Title id="dash-player-modal">{this.getPreviewTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>{this.state.playVideo.title?this.state.playVideo.title:''}</h4>
            <p>
              <a href={this.getDashLink()}>{this.getDashLink()}</a>
            </p>
            <video id="video"
              width="100%"
              poster="//shaka-player-demo.appspot.com/assets/poster.jpg"
              controls autoplay></video>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeVideo}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          {...this.props}
          bsSize="large"
          aria-labelledby='preview-player-modal'
          show={this.state.showMulticastVideoModal}
          onHide={this.closeMulticastVideo}
        >
          <Modal.Header closeButton>
            <Modal.Title id="preview-player-modal">Preview Stream</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>{this.state.playVideo.title?this.state.playVideo.title:''}</h4>
            <div className="col-md-4">
              <a href={this.state.playVideo.videoUrl}>{this.state.playVideo.videoUrl}</a>
            </div>
            <div className={"form form-horizontal col-md-8"}>
                <KeyValueDropdown
                  ncols={["col-md-12"]}
                  onValueChange={this.updateState}
                  statekey="remoteControl"
                  keyvalue="program_id"
                  keytext="display_text"
                  hidden={this.state && this.state.programids && this.state.programids.length == 0}
                  proprieties={[
                    {
                      label: "Programs",
                      type: "text",
                      bsClass: "form-control",
                      placeholder: "Select Program",
                      children: this.state.programids
                    }
                  ]}
                />
            </div>
            <video id="video_preview" poster="//shaka-player-demo.appspot.com/assets/poster.jpg" className="video-js vjs-default-skin" width="100%" controls preload="auto" data-setup="{}"></video>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeMulticastVideo}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

StreamList.propTypes = {
  actions: PropTypes.object.isRequired

};

function getContainers(state) {
  let containers = state.streamList.containers;
  // if (containers[0] && !containers[0].sourceProtocol)
  //   containers = {};

  return containers;
}

function mapStateToProps(state) {
  return {
    containers: getContainers(state),
    inputStatus: state.srtStats.containerStatusInput,
    outputStatus: state.srtStats.containerStatusOutput,
    pageSize: state.streamList.localConfig.pageSize,
    enableTSStats: state.sysConfig.about.enableTSStats,
    enableVideoPreview: state.sysConfig.about.enableVideoPreview
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
   
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(StreamList));
